import classNames from 'classnames';
import styles from 'components/ui-blocks/placeholder/index.module.scss';
import { Td, Tr } from 'components/ui-blocks/table';
import { range } from 'lodash-es';
import type { CSSProperties } from 'react';
import React from 'react';
import type { ReactChildren } from 'types/utility';

export const TdPlaceholder: React.FC<{ style?: CSSProperties }> = ({ style }) => (
  <div style={{ width: '100%', margin: 0, ...style }} className={classNames(styles['ph-row'])}>
    <div
      style={{ marginBottom: 0 }}
      className={classNames(styles['ph-item'], styles['ph-col-12'])}
    />
  </div>
);

export const TableRowPlaceholder: React.FC<{
  rowCount: number;
  colCount: number;
  placeHolder: React.ReactNode;
  children?: ReactChildren;
}> = ({ rowCount, colCount, placeHolder, children }) => {
  const table = range(rowCount).map(i => {
    return (
      <Tr key={i}>
        {range(colCount).map(idx => {
          return <Td key={idx}>{placeHolder}</Td>;
        })}
        {children}
      </Tr>
    );
  });
  return <>{table}</>;
};
